import React from 'react';
import './desktopNavigation.module.scss';
import classNames from 'classnames';
import { NavigationTrialButton } from '../TrialButton';
import { NavigationLoginButton } from '../NavigationLoginButton';
import { Logo } from '../../../../../commonv2/components/navigation/LikesLogo';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../../routes';
import { SpBr } from '../../../../../commonv3/components/atoms/layouts/br';

type Props = {
    children: any;
    background: 'transparent' | 'white';
    topUrl: { pathname: string; hash: string } | string;
};

export const DesktopNavigation = ({ children, background, topUrl }: Props) => {
    return (
        <div styleName={classNames('desktop-header-wrapper', background)}>
            <div styleName="desktop-header">
                <Logo
                    styleName={classNames('header-logo', background)}
                    onClick={() => GlobalStatesV3.routing.push(topUrl as any)}
                />
                <div styleName="header-body">
                    <div styleName="header-items">{children}</div>
                    <NavigationTrialButton styleName="trial-button">
                        WEBで簡単！<SpBr />無料体験はこちら
                    </NavigationTrialButton>
                    <NavigationLoginButton
                        withBorder={background === 'white'}
                        styleName="login-button"
                        onClick={() => GlobalStatesV3.routing.push(V3Routes.signIn())}
                    >
                        ログイン
                    </NavigationLoginButton>
                </div>
            </div>
        </div>
    );
};
